<template>
  <form-item-label label="就業状況" :required="true" />
  <complemented-text-form
    v-if="complementedTextOpened"
    :text="complementedText"
    @open="openForm"
    :editable="true"
    :colspan="1"
  />
  <td v-if="!complementedTextOpened">
    <div class="m3p-contact__input m3p-contact__start">
      <div class="m3p-form-item__contact">
        <ul class="m3p-form-radio">
          <radio-form
            :name="fieldName"
            :selectableItems="selectiveWorkStatusList"
            :validator="validator"
            :dispatcher="dispatcher"
          />
        </ul>
        <error-message :name="fieldName" />
      </div>
    </div>
  </td>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import RadioForm from '@component_path/pages/common/form/element/radio';
import { useWorkStatusField } from '@component_path/inquiry_form_common_module/custom_hook/WorkStatus';

const store = useStore();

const props = defineProps({
  defaultWorkStatus: {
    type: Number,
    required: false,
    default: 1
  }
});

const { fieldName, validator } = useWorkStatusField(true);
const dispatcher = ref('positionInquiryMail/setWorkStatus');

const complementedTextOpened = ref(false);
const selectiveWorkStatusList = ref([
  { code: 1, text: '在籍中' },
  { code: 2, text: '離職中' }
]);

const workStatus = computed(
  () => store.state.positionInquiryMail.formData.work_status
);
const complementedText = computed(() => {
  if (workStatus.value === null) {
    return '';
  }
  const selectedWorkStatus = selectiveWorkStatusList.value.find(
    item => item.code === workStatus.value
  );
  return selectedWorkStatus ? selectedWorkStatus.text : '';
});

const openForm = () => (complementedTextOpened.value = false);

onMounted(() => {
  if (!!workStatus.value) {
    complementedTextOpened.value = true;
  } else {
    store.dispatch(dispatcher.value, props.defaultWorkStatus);
  }
});
</script>
